import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";
const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};
function AbstractPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Abstract</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              The greatest challenge of the 21<sup>st</sup> century for a nation
              is to cater to the growing demand for energy for transportation,
              heating, lighting, and industrial processes. The increased demand
              for fossil oil and its impacts on the environment with greenhouse
              gas (GHG) emissions have necessitated finding sustainable energy
              alternatives. Biofuel is emerging as a viable alternative to
              fossil fuels with the potential for renewability and optimal use
              of biological residues. Ethanol is the most common renewable fuel
              being produced from biomass such as bagasse or straws. Unlike
              fossil fuel deposits, biomass is considered a potentially
              sustainable renewable resource due to its shorter period of
              cycling time and availability at decentralised levels for bio-fuel
              production and energy generation to meet the local energy demand.
              Ethanol is being manufactured conventionally from first-generation
              feedstocks such as sugar cane and starch-containing food crops
              which pose severe challenges due to the potential threat to food
              and water security. Subsequent research focussed on
              lignocellulosic biomass (second generation) feedstocks, involving
              the conversion of lignocellulosic polymer to ethanol through
              hydrolysis (to breakdown the lignin-cellulose matrix and produce
              simple sugars such as glucose) followed by fermentation (to
              metabolize glucose towards ethanol). Research involving
              bio-ethanol production from lignocellulosic waste materials has
              included agricultural residues, forest products, municipal solid
              waste, industrial wastes, municipal sludge, leaf and yard waste,
              and a few studies involving cattle and dairy manures. Large-scale
              burning of agricultural residues and consequent environmental
              implications in developing countries and the need for sustainable
              energy alternatives necessitated an assessment of the potential of
              agriculture residues and conversion to technically feasible and
              economically viable fuel.
            </p>
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default AbstractPage;
